import { hasMany, belongsTo, attr } from '@ember-data/model';
import ShModel from './sh-model';
import { computed } from '@ember/object';

export default ShModel.extend({
  body: attr('string'),
  threadId: attr('number'),
  userId: attr('number'),
  createdAt: attr('date'),
  updatedAt: attr('date'),

  //Relationships
  user: belongsTo('user', { async: false }),
  thread: belongsTo('thread', { async: false }),
  actions: hasMany('action', {
    async: false,
    inverse: 'actionable',
  }),
  assets: hasMany('asset', {
    async: false,
    polymorphic: true,
  }),

  /**
   * Returns a boolean indicating the presence of a disintermediation action on the message
   * @param actions
   * @returns {Boolean}
   */
  hasDisintermediationWarning: computed('actions.@each.name', function () {
    return Boolean(this.actions.find(action => action.name === 'message_disintermediation_warning'));
  }),
});
